<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="13.99" height="12.056" viewBox="0 0 13.99 12.056">
    <title>Vimeo</title>
    <path d="M13.985,3.357q-.093,2.038-2.853,5.582-2.855,3.7-4.83,3.7-1.223,0-2.068-2.258L3.106,6.24q-.63-2.26-1.348-2.258a4.276,4.276,0,0,0-1.1.659L0,3.794,2.034,1.974A4.63,4.63,0,0,1,4.1.72c1.093-.1,1.76.639,2.011,2.246l.565,3.2Q7.147,8.3,7.712,8.3q.439,0,1.318-1.379a5.389,5.389,0,0,0,.942-2.1Q10.1,3.628,9.03,3.627A2.728,2.728,0,0,0,8,3.846C8.668,1.61,10,.522,11.947.584q2.164.063,2.038,2.791Z" />
  </svg>
</template>
